<template>
  <b-modal
    ref="modal"
    class="modal-prize"
    content-class="rounded-10 border-0 overflow-hidden"
    dialog-class="prize-dialog"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    :visible="show"
    centered
  >
    <div class="prize">
      <!-- 上半部：橘色 banner -->
      <div class="banner">
        <i class="icon-Gift" />
        <h3 class="title">
          {{ $t('恭喜獲得 {months} 個月 VIP', {months: vipMonths}) }}
        </h3>
        <p class="subtitle">{{ $t('專屬獎勵已發放！') }}</p>
      </div>

      <!-- 下半部：VIP 卡 + 權益列表 + 按鈕 -->
      <div class="body">
        <div class="vip-reward-card">
          <div class="vip-badge">
            <i class="icon-VIP" />
          </div>
          <div class="vip-reward-info">
            <span class="reward-label">{{ $t('專屬獎勵') }}</span>
            <span class="reward-name">{{ $t('VIP方案') }}</span>
          </div>
          <span class="reward-duration">
            {{ $t('{days}天', {days: vipDays}) }}
          </span>
        </div>

        <ul class="benefits-list">
          <li v-for="benefit in benefits" :key="benefit">
            <i class="icon-Circle-check"></i>
            <span>{{ $t(benefit) }}</span>
          </li>
        </ul>

        <button class="confirm-btn" @click="onConfirm">
          {{ $t('太棒了！') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    vipMonths: {
      type: Number,
      default: 1,
    },
    vipDays: {
      type: Number,
      default: 31,
    },
  },
  data() {
    return {
      benefits: [
        '棋魂對決 解鎖所有角色',
        '天梯闖關 無限體力',
        '棋譜圖表覆盤',
        '19 路拍照數地',
      ],
    };
  },
  methods: {
    onConfirm() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.prize-dialog) {
  width: 288px;
  max-width: 288px;
  margin: 0 auto;
  .modal-body {
    padding: 0;
  }
}

.prize {
  display: flex;
  flex-direction: column;
  background: $white;

  // ── Banner ─────────────────────────────────
  .banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
    background: $primary;
    color: $white;
    text-align: center;
    .icon-Gift {
      font-size: 78px;
      line-height: 1;
    }
    .title {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      line-height: 30px;
    }
    .subtitle {
      margin: 0;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
    }
  }

  // ── Body ───────────────────────────────────
  .body {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 16px;
  }

  // ── VIP 獎勵卡 ──────────────────────────────
  .vip-reward-card {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 24px;
    border-radius: 20px;
    background: $bgsection;
    .vip-badge {
      width: 48px;
      height: 48px;
      flex-shrink: 0;
      border-radius: 10px;
      background: $secondary;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 32px;
        color: $white;
      }
    }
    .vip-reward-info {
      display: flex;
      flex-direction: column;
      flex: 1;
      .reward-label {
        font-size: 12px;
        line-height: 20px;
        color: $font-grayscale-2;
      }
      .reward-name {
        font-size: 18px;
        font-weight: 700;
        line-height: 30px;
        color: $font-normal;
      }
    }
    .reward-duration {
      font-size: 12px;
      line-height: 20px;
      color: $accent;
      flex-shrink: 0;
    }
  }

  // ── 權益列表 ────────────────────────────────
  .benefits-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
    li {
      display: flex;
      align-items: center;
      gap: 8px;
      i {
        font-size: 24px;
        color: $primary;
        flex-shrink: 0;
      }
      span {
        font-size: 16px;
        line-height: 28px;
        color: $font-normal;
      }
    }
  }

  // ── 按鈕 ──────────────────────────────────
  .confirm-btn {
    width: 100%;
    height: 38px;
    padding: 5px 12px;
    border: none;
    border-radius: 19px;
    background: $primary;
    color: $white;
    font-size: 16px;
    line-height: 28px;
    cursor: pointer;
    transition: opacity 0.15s ease;
    &:hover {
      opacity: 0.9;
    }
  }
}
</style>
